import { createContext } from "react";

const HabitsContext = createContext();

export default HabitsContext;
